export default "__VITE_ASSET__86a1b879__"